export const GET_PLANOGRAM_EDITION_DATA = 'GET_PLANOGRAM_EDITION_DATA';
export const CLEAR_PLANOGRAM_EDITION_DATA = 'CLEAR_PLANOGRAM_EDITION_DATA';
export const SET_STORE_SELECTION_AND_TAB = 'SET_STORE_SELECTION_AND_TAB';

